import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { DEALER_PROPS, DEALER_REVIEWS_PER_PAGE, DEFAULT_REVIEWS_TYPE } from 'client/constants/dealer-reviews';
import { getListInitialParams } from 'site-modules/dealerships/utils/get-list-initial-params';
import { isEdmundsReferrer } from 'site-modules/dealerships/utils/is-referred-url-from-edmunds';
import { useTrackInternalReferrer } from 'site-modules/dealerships/utils/use-track-internal-referrer';
import { DealerReviewsSection } from 'site-modules/dealerships/components/dealer-reviews-section/dealer-reviews-section';

const DealerReviewsListUI = ({ reviewsType, params, location = {}, isMobile = false, overallData, referer = '' }) => {
  const [isShowNextPageButton, setShowNextPageButton] = useState(false);
  const onShowNextPage = useCallback(value => setShowNextPageButton(value), []);

  useTrackInternalReferrer(location);

  const { initialCount, pageNumber } = useMemo(() => {
    return getListInitialParams(location, reviewsType, {
      isInternalReferrer: isEdmundsReferrer(referer),
    });
  }, [location, referer, reviewsType]);

  const { totalCount, newReviewsCount } = overallData;

  const showNextPageButton = isShowNextPageButton && pageNumber * DEALER_REVIEWS_PER_PAGE < totalCount;

  return (
    <div>
      <DealerReviewsSection
        reviewsType={reviewsType}
        params={params}
        isMobile={isMobile}
        initialCount={initialCount}
        totalReviews={totalCount}
        newReviewsCount={newReviewsCount}
        onMaxAmountExpanded={onShowNextPage}
      />

      {showNextPageButton && (
        <div className="text-center mt-2">
          <a
            className={classnames('btn btn-blue-50 rounded-8 text-transform-none fw-medium size-16', {
              'w-100': isMobile,
            })}
            href={`?page=${pageNumber + 1}${reviewsType !== DEFAULT_REVIEWS_TYPE ? `&type=${reviewsType}` : ''}`}
            data-tracking-id="ddp_view_dealer_reviews"
            data-tracking-value={`read ${reviewsType} reviews`}
          >
            Next Page
          </a>
        </div>
      )}
    </div>
  );
};

DealerReviewsListUI.propTypes = {
  reviewsType: PropTypes.string.isRequired,
  params: DEALER_PROPS.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  isMobile: PropTypes.bool,
  referer: PropTypes.string,
  overallData: PropTypes.shape({
    totalCount: PropTypes.number,
    newReviewsCount: PropTypes.number,
  }).isRequired,
};

const mapStateToProps = state => ({
  referer: state.pageContext?.page?.referer,
});

export const DealerReviewsList = withRouter(connect(mapStateToProps)(DealerReviewsListUI));
